module.exports = __webpack_public_path__ + "static/media/Minotaur.c2eafec9.jpg";